import { requestGet } from '../utils/request';

const BASE_URL = '/api/farms/';

/**
 * Get farm details
 * @param {String} farmUuid
 * @return {Promise} Response
 */
export function requestFarmDetails(farmUuid) {
  return requestGet(`${BASE_URL}${farmUuid}`, {
    mockFile: 'farm/default',
  });
}
